import moment from 'moment'
export default {
    findPendingRequest(uid) {
        return {
            "query": {
                "bool": {
                    "must": [
                        {
                            "range": {
                                "sender.update_date._seconds": {
                                    "gte": moment().valueOf() / 1000,
                                }
                            }
                        },
                        {
                            "range": {
                                "receiver.update_date._seconds": {
                                    "gte": moment().valueOf() / 1000,
                                }
                            }
                        },
                        {
                            "term": {
                                "status": "pending"
                            }
                        },
                        {    
                            "term": {
                                "receiver.uid": uid
                            }
                        }
                    ]    
                }
            }
        }
    }
} 